export default {
    employee: {
		id:"",
        employeeNo: "",
        trueName: "",
		avatar:"",
        createAt: "",
		shopIdList:[],
		shopList:[],
        super: false
    },
	currentShop:{
		id:"",
		shopLogo:""
	}, // 当前校区
    x: false,
	routeTree: [],
    config: {
        es_index_user: window.location.href.indexOf("localhost") >= 0 ? 'test_basic_message' : "prod_basic_message",
        baseUrl: process.env.VUE_APP_API_BASE_URL || (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' ? 'http://localhost:9009/api' : 'https://api-prod.youkeya.cn/api'),
        imgPre: "https://photo.youkeya.cn/",
		imgSize50:"?imageView2/1/w/100/h/100",
        linkPre: window.location.href.indexOf("localhost") >= 0 ? 'http://localhost/' : (window.location.href.indexOf("-test") >= 0 ? 'https://api-test.youkeya.cn/' : 'https://api-prod.youkeya.cn/'),  
    },
	weekList:[
		{week: "1",weekName: "周一"},
		{week: "2",weekName: "周二"},
		{week: "3",weekName: "周三"},
		{week: "4",weekName: "周四"},
		{week: "5",weekName: "周五"},
		{week: "6",weekName: "周六"},
		{week: "0",weekName: "周日"},
	]
};
